import { TFunction } from 'i18next';
import { getApiErrorField, getApiErrorMessage } from './apiError';

/**
 * What the operator reads when a hard delete is refused. One place for every
 * surface that deletes a booking, so the refusal reads the same everywhere.
 *
 * An issued invoice gets its own translated sentence (#2840 F2): the booking
 * must be kept under §147 AO, and the way forward is archive + anonymize. It
 * resolves `api_errors.<code>` the way `errorMessageFrom` does, so the key sits
 * with the other coded refusals and their DE/EN parity test covers it.
 *
 * Anything else keeps the generic text with the server's own reason appended:
 * "try again later" is unactionable when the cause is a specific constraint,
 * and `getApiErrorMessage` reduces a multi-line Prisma error to its last line,
 * which `errorMessageFrom` would print whole.
 */
export const deleteBookingErrorMessage = (
    error: unknown,
    t: TFunction,
    fallbackKey = 'booking_details.delete_booking.error_message',
): string => {
    const invoiceNumber = getApiErrorField(error, 'invoiceNumber');
    if (getApiErrorField(error, 'code') === 'invoiced_booking' && invoiceNumber) {
        const translated = t('api_errors.invoiced_booking', { invoiceNumber, defaultValue: '' });
        if (translated) return translated;
    }
    const reason = getApiErrorMessage(error);
    const message = t(fallbackKey);
    return reason ? `${message} (${reason})` : message;
};
